import { useLiquidGlassPress } from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import { hapticFeedback } from '@tma.js/sdk';
import type { ListQuest } from '../../client/types';
import { openExternalQuest } from '../../helpers/externalQuest';
import { CommonIcon } from '../common/CommonIcon';

export type ExternalQuestButtonProps = {
    external: NonNullable<ListQuest['external']>;
    externalDeepLink?: string | null;
    questName: string;
    onPressedChange?: (pressed: boolean) => void;
};

export const ExternalQuestButton = ({ external, externalDeepLink, questName, onPressedChange }: ExternalQuestButtonProps) => {
    const { pressed, onPointerDown, onPointerMove, onPointerUp, onPointerCancel, onClick } = useLiquidGlassPress({
        preventDefault: true,
        onPressedChange,
        onActivate: () => {
            hapticFeedback.impactOccurred.ifAvailable('light');
            openExternalQuest(external, externalDeepLink);
        },
    });

    return (
        <Box
            component="button"
            type="button"
            aria-label={`Open ${questName}`}
            onClick={onClick}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
            onPointerCancel={onPointerCancel}
            sx={{
                width: '100%',
                height: '100%',
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                WebkitTapHighlightColor: 'transparent',
                outline: 'none',
                bgcolor: pressed ? 'color-mix(in srgb, var(--tg-theme-text-color) 8%, transparent)' : 'transparent',
                transition: 'background-color 0.12s ease',
            }}
        >
            <CommonIcon color="var(--tgui--button_color)" size={26} icon="launch" type="filled" />
        </Box>
    );
};
